import React, { useEffect, useState } from "react";
import gql from "graphql-tag";
import HttpLinkServices from "../../services/HttpLinkServices";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";

import getCookie from "./../../components/Cookie/Cookie.jsx";
import AccountService from "./../../services/AccountService";
import iconBotMeuPortoSeguro from "./icons/atendimento-bot-meu-porto-seguro.svg";

import "./styles.css";

const accountService = new AccountService();

const account_client = new ApolloClient({
  link: HttpLinkServices.account,
  cache: new InMemoryCache(),
});

export function AtendimentoButton() {
  const [parceiro, setParceiro] = useState();

  let windowObjectReference = null;

  function openChatPopup() {
    if (windowObjectReference == null || windowObjectReference.closed) {
      windowObjectReference = window.open(
        "https://wwws.portoseguro.com.br/atendimento-online/xwc/xwc.dll?f=F4007&ct=CENTRAL_CARTOES_PORTO&sel=MeuPortoSeguro&cpf=&nome=",
        "PortoEducChat",
        "resizable,scrollbars,status, width=500,height=650"
      );
    } else {
      windowObjectReference.focus();
    }
  }

  useEffect(() => {
    async function getUser() {
      const token_user = getCookie("token_user");
      return account_client
        .query({
          variables: { token: token_user },
          query: gql`
            query getUser($token: String!) {
              get_user_by_token(token: $token) {
                id
                name
                profileString
                susepString
                sucursalString
                numberString
              }
            }
          `,
        })
        .then(async (result) => {
          const userId = result.data.get_user_by_token.id;
          const response = await accountService.getUserMetas(userId);
          const userMetas = response.data.user.userMetas;
          const metasFiltered = userMetas.find((meta) => {
            return (
              meta.account_field_value.value === "Meu Porto Seguro - Aprovados"
            );
          });
          if (metasFiltered) {
            setParceiro(true);
            return true;
          } else {
            setParceiro(false);
            return false;
          }
        });
    }
    getUser();
  }, []);

  return !parceiro ? null : (
    <div>
      <button className="helpButton" data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name="posso ajudar" onClick={openChatPopup}>
        <img className="atendimentoIcon" src={iconBotMeuPortoSeguro} />
        Posso ajudar?
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/atendimentoButton/index.js